"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionFeatures = exports.QuestionTagged = exports.QuestionDescription = exports.Question = exports.ValidationResults = exports.QuestionClassification = exports.QuestionPublished = exports.LanguagesResourceUsage = exports.MethodInfo = exports.Citation = exports.QuestionPath = exports.QuestionType = void 0;
const jeed_types_1 = require("@cs124/jeed-types");
const runtypes_1 = require("runtypes");
const languages_1 = require("./languages");
const linecounts_1 = require("./linecounts");
const linecoverage_1 = require("./linecoverage");
exports.QuestionType = (0, runtypes_1.Union)((0, runtypes_1.Literal)("SNIPPET"), (0, runtypes_1.Literal)("METHOD"), (0, runtypes_1.Literal)("KLASS"));
exports.QuestionPath = (0, runtypes_1.Record)({
    path: runtypes_1.String,
    author: runtypes_1.String,
    version: runtypes_1.String,
});
exports.Citation = (0, runtypes_1.Record)({ source: runtypes_1.String }).And((0, runtypes_1.Partial)({ link: runtypes_1.String }));
exports.MethodInfo = (0, runtypes_1.Record)({
    className: runtypes_1.String,
    methodName: runtypes_1.String,
    descriptor: runtypes_1.String,
});
exports.LanguagesResourceUsage = (0, runtypes_1.Record)({
    java: runtypes_1.Number,
}).And((0, runtypes_1.Partial)({
    kotlin: runtypes_1.Number,
}));
exports.QuestionPublished = exports.QuestionPath.And((0, runtypes_1.Record)({
    contentHash: runtypes_1.String,
    name: runtypes_1.String,
    type: exports.QuestionType,
    packageName: runtypes_1.String,
    languages: (0, runtypes_1.Array)(languages_1.Languages),
    descriptions: (0, runtypes_1.Dictionary)(runtypes_1.String, languages_1.Languages),
    templateImports: (0, runtypes_1.Array)(runtypes_1.String),
    questionerVersion: runtypes_1.String,
    authorName: runtypes_1.String,
    klass: runtypes_1.String,
})).And((0, runtypes_1.Partial)({
    citation: exports.Citation,
    starters: (0, runtypes_1.Dictionary)(runtypes_1.String, languages_1.Languages),
    tags: (0, runtypes_1.Array)(runtypes_1.String),
    kotlinImports: (0, runtypes_1.Array)(runtypes_1.String),
    javaTestingImports: (0, runtypes_1.Array)(runtypes_1.String),
    kotlinTestingImports: (0, runtypes_1.Array)(runtypes_1.String),
}));
exports.QuestionClassification = (0, runtypes_1.Record)({
    featuresByLanguage: (0, runtypes_1.Dictionary)(jeed_types_1.FeatureValue, languages_1.Languages),
    complexity: (0, runtypes_1.Dictionary)(runtypes_1.Number, languages_1.Languages),
    lineCounts: (0, runtypes_1.Dictionary)(linecounts_1.LineCounts, languages_1.Languages),
}).And((0, runtypes_1.Partial)({
    recursiveMethodsByLanguage: (0, runtypes_1.Dictionary)((0, runtypes_1.Array)(exports.MethodInfo), languages_1.Languages),
    loadedClassesByLanguage: (0, runtypes_1.Dictionary)((0, runtypes_1.Array)(runtypes_1.String), languages_1.Languages),
}));
exports.ValidationResults = (0, runtypes_1.Record)({
    seed: runtypes_1.Number,
    requiredTestCount: runtypes_1.Number,
    mutationCount: runtypes_1.Number,
    solutionMaxRuntime: runtypes_1.Number,
    bootstrapLength: runtypes_1.Number,
    mutationLength: runtypes_1.Number,
    incorrectLength: runtypes_1.Number,
    calibrationLength: runtypes_1.Number,
    solutionCoverage: linecoverage_1.LineCoverage,
    executionCounts: exports.LanguagesResourceUsage,
    memoryAllocation: exports.LanguagesResourceUsage,
}).And((0, runtypes_1.Partial)({
    solutionMaxClassSize: exports.LanguagesResourceUsage,
    canTestTest: runtypes_1.Boolean,
}));
exports.Question = (0, runtypes_1.Record)({
    published: exports.QuestionPublished,
    classification: exports.QuestionClassification,
}).And((0, runtypes_1.Partial)({
    validationResults: exports.ValidationResults,
}));
exports.QuestionDescription = exports.QuestionPath.And((0, runtypes_1.Record)({
    name: runtypes_1.String,
    description: runtypes_1.String,
    packageName: runtypes_1.String,
    starter: runtypes_1.String,
}));
exports.QuestionTagged = exports.QuestionPublished.And((0, runtypes_1.Record)({
    tags: (0, runtypes_1.Array)(runtypes_1.String),
}));
const questionFeatures = (question) => (0, runtypes_1.Array)(jeed_types_1.Feature)
    .check(Object.keys(question.classification.featuresByLanguage.java.featureMap))
    .filter((feature) => question.classification.featuresByLanguage.java.featureMap[feature] > 0);
exports.questionFeatures = questionFeatures;
//# sourceMappingURL=question.js.map